export default {
  REQUIRED_ERROR_MESSAGE: "Este campo es obligatorio",
  REQUIRED_MEMBERSHIP: "Debes seleccionar una membresia para continuar.",
  REQUIRED_CREDIT_CARD: "Debes agregar una tarjeta",
  SIGN_DOCUMENT: "Personas menores de edad deben firmar consentimiento",
  INVALID_DOCUMENT_ID: "Debes ingresar un DPI valido.",
  INVALID_PHONE: "Debes ingresar un numero de telefono valido.",
  EXIST_DOCUMENT_ID: "Este DPI ya se encuentra registrado para otro socio, por favor pasar a recepción.",
};
